import React from 'react';
import PageSyle from '../style';
import CourseCDS from '../../../components/CourseCDS';
import CourseCDSBGImage from '../../../images/ComponentImages/weights.png';

export default function Page00({nextPressed, backPressed, courseInfo}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CourseCDS
				title={courseInfo.displayName}
				meta={courseInfo.meta}
				nav={{next: nextPressed, back: backPressed}}
				bgImage={CourseCDSBGImage}
				workoutTumbnail={courseInfo.thumbnail}
			/>
		</div>
	);
}
